import { useQuery } from 'react-query'

import { getPersonalWorkouts } from '../api/personal-workouts/getPersonalWorkouts'

export const usePersonalWorkoutsQuery = () => useQuery(['personal-workouts'], getPersonalWorkouts)
